import {
  resolveTranscriptSpeakerDisplayLabel,
  type TranscriptSpeakerDisplayArgs,
} from "@/modules/audio-recording/transcript-speaker-labels";

/**
 * Resolves the participant name that should be rendered as a voice transcript bubble badge.
 */
export function resolveTranscriptSpeakerBadgeName({
  isSelfSpeaker,
  isTranscriptOnly,
  ...displayArgs
}: TranscriptSpeakerDisplayArgs & {
  isSelfSpeaker: boolean;
  isTranscriptOnly: boolean;
}): string | null {
  if (isSelfSpeaker || isTranscriptOnly) {
    return null;
  }

  const displayLabel = resolveTranscriptSpeakerDisplayLabel(displayArgs);
  return displayLabel.source === "participant" ? displayLabel.label : null;
}
